// Vue.directive('debounce', {
//     inserted:
//   });
const debounce= {
  inserted:function (el, binding) {
    let {type = "input", fn, event = "keydown", time = 300} = binding.value
    const targetEl = el.getElementsByTagName(type)[0];
    let timer
    targetEl.addEventListener(event, (e) => {
      let  code=e.keyCode
      if(code==100||code==37||code==38||code==39||code==40) return
      timer && clearTimeout(timer)
      // console.log(targetEl.value)
      timer = setTimeout(() => fn(targetEl.value), time)
    })
  }}
export default debounce



// WEBPACK FOOTER //
// ./src/directives/src/debounce.js